/**
 * 统计
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import "./index.less";
import IconFont from "@components/IconFont/index";
import dayjs from 'dayjs';
import {
    toFixedWithCommas,
    numberWithCommas,
} from "../../../../utils/number-util";
class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let model = this.props.model;
        let list = [
            {
                iconName: "icon-weizhifudingjindingdanshu",
                name: __getServerLanguage('WeiZhiFuDingJinDingDanShu'),
                num: model.unconfirmedPONum,
            },
            {
                iconName: "icon-jinniancaigouzongjine",
                name: __getServerLanguage('JinNianCaiGouZongJinE'),
                num: (model.currencySymbol||'')+' '+(model.thisYearPOPriceTotal?numberWithCommas(toFixedWithCommas(model.thisYearPOPriceTotal,2)):'-'),
            },
            {
                iconName: "icon-jinniandingdanshu",
                name: __getServerLanguage('JinNianDingDanShu'),
                num: model.thisYearPONumTotal,
            },
            {
                iconName: "icon-weikuan",
                name: __getServerLanguage('WeiZhiFuWeiKuanDingDanShu'),
                num: model.unPaidBalancePONum,
            },
            {
                iconName: "icon-analytics-graph-chart1",
                name: __getServerLanguage('LeiJiCaiGouZongJinE'),
                num: (model.currencySymbol||'')+' '+(model.poPriceTotal?numberWithCommas(toFixedWithCommas(model.poPriceTotal,2)):'-'),
            },
            {
                iconName: "icon-leijidingdanshu",
                name: __getServerLanguage('LeiJiDingDanShu'),
                num: model.poNumTotal,
            },
            {
                iconName: "icon-shoucichengjiaoshijian",
                name: __getServerLanguage('ShouCiChengJiaoShiJian'),
                num: model.firstOrderTime?dayjs(model.firstOrderTime).format("YYYY-MM-DD"):'-',
            },
            {
                iconName: "icon-zuijinchengjiaoshijian",
                name: __getServerLanguage('ZuiJinChengJiaoShiJian'),
                num: model.lastOrderTime?dayjs(model.lastOrderTime).format("YYYY-MM-DD"):'-',
            },
        ];
        return (
            <div>
                <ul className="statistics-wrap">
                    {list.map(function (item, index) {
                        return (
                            <li key={index}>
                                <IconFont
                                    type={item.iconName}
                                    className="img"
                                ></IconFont>
                                <div>
                                    <p className="statistics-title">
                                        {item.name}
                                    </p>
                                    <p className="num">{item.num || "0"}</p>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

Statistics.defaultProps = {
    model: {},
};

Statistics.propTypes = {};
export default Statistics;
